import React from 'react'
import { connect } from 'react-redux'
import OrderActions from '../../Redux/OrderRedux'
import moment from 'moment'
import accounting from 'accounting'
import { currentBranch } from '../../Utils/PrivilegeUtils'

class ViewDetail extends React.Component {
  constructor (props) {
    super(props)
    this.dateFormat = 'DD MMM YYYY, h:mm:ss a'
    this.state = {
      showModal: null
    }
    this.currentBranch = currentBranch()
  }

  componentDidMount = () => {
    this._fetchData()
  }

  _fetchData = () => {
    this.props.getData(this.props.order_id)
  }

  _renderAttraction = (data) => {
    return (
      <section className='section table-responsive'>
        <h5>Attractions</h5>
        <table className='table table-striped'>
          <thead>
            <tr>
              <th>Booking number</th>
              <th>Product type</th>
              <th>Attraction title </th>
              <th>Attraction package</th>
              <th>Provider</th>
              <th>Quantity</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {
              data.order_details && data.order_details.map((item, i) => {
                if (item.type === 'attraction') {
                  return (
                    <tr key={i}>
                      <td>{ item.booking_number || '-' }</td>
                      <td>{ item.type || '-' }</td>
                      <td>{ item.orderable.attraction.title || '-' }</td>
                      <td>{ item.orderable.attraction_package.title || '-' }</td>
                      <td>{ item.orderable.provider || '-' }</td>
                      {
                        item.orderable.provider === 'BMG'
                          ? <td>
                            { item.orderable.adults > 0 && <span>{`${item.orderable.adults} Adult`}</span> }<br />
                            { item.orderable.children > 0 && <span>{`${item.orderable.children} Children`}</span> }<br />
                            { item.orderable.seniors > 0 && <span>{`${item.orderable.senior} Senior`}</span> }
                          </td>
                          : <td>
                            <ul>
                              {
                                item.orderable.skus.map((item, i) => (
                                  <li key={i}>
                                    {`${item.quantity} ${item.title}`}
                                  </li>
                                ))
                              }
                            </ul>
                          </td>
                      }
                      <td>{ moment(item.orderable.date).format(this.dateFormat) || '-' }</td>
                    </tr>
                  )
                } else return null
              })
            }
          </tbody>
        </table>
      </section>
    )
  }

  _renderModem = (data) => {
    return (
      <section className='section table-responsive'>
        <h5>Modem</h5>
        <table className='table table-striped'>
          <thead>
            <tr>
              <th>Booking number</th>
              <th>Start Date</th>
              <th>End date</th>
              <th>Qty</th>
              <th>Wifi plan</th>
            </tr>
          </thead>
          <tbody>
            {
              data.order_details && data.order_details.map((item, i) => {
                if (item.type === 'modem') {
                  return (
                    <tr key={i}>
                      <td>{ item.booking_number || '-' }</td>
                      <td>{ moment(item.orderable.start_date).format(this.dateFormat) || '-' }</td>
                      <td>{ moment(item.orderable.end_date).format(this.dateFormat) || '-' }</td>
                      <td>{ item.orderable.qty || '-' }</td>
                      <td>{ item.orderable.product.title || '-' }</td>
                    </tr>
                  )
                } else return null
              })
            }
          </tbody>
        </table>
      </section>
    )
  }

  _renderEvents = (data) => {
    return (
      <section className='section table-responsive'>
        <h5>Events</h5>
        <table className='table table-striped'>
          <thead>
            <tr>
              <th>Booking Number</th>
              <th>Event Name</th>
              <th>Location</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Quantity</th>
            </tr>
          </thead>
          <tbody>
            {
              data.order_details && data.order_details.map((item, i) => {
                if (item.type === 'event') {
                  return (
                    <tr key={i}>
                      <td>{ item.booking_number || '-' }</td>
                      <td>{ item.orderable.events.name || '-' }</td>
                      {
                        !item.orderable.events.schedules.length
                          ? <td>No Location</td>
                          : <td>
                            {
                              item.orderable.events.schedules.map((item, i) => (
                                <div key={i}>{ item.location.location_name || '-' }</div>
                              ))
                            }
                          </td>
                      }
                      <td>{ moment(item.orderable.events.start_date).format(this.dateFormat) || '-' }</td>
                      <td>{ moment(item.orderable.events.end_date).format(this.dateFormat) || '-' }</td>
                      <td>{ item.orderable.qty || '-' }</td>
                    </tr>
                  )
                } else return null
              })
            }
          </tbody>
        </table>
      </section>
    )
  }

  _renderInsurance = (data) => {
    return (
      <section className='section table-responsive'>
        <h5>Insurance</h5>
        <table className='table table-striped'>
          <thead>
            <tr>
              <th>Booking Number</th>
              <th>Package Name</th>
              <th>Type</th>
              <th>Destination</th>
              <th>Start Day</th>
              <th>End Day</th>
              <th>Price</th>
            </tr>
          </thead>
          <tbody>
            {
              data.order_details && data.order_details.map((item, i) => {
                if (item.type === 'insurance') {
                  return (
                    <tr key={i}>
                      <td>{ item.booking_number || '-' }</td>
                      <td>{ item.orderable.travel_package.name || '-' }</td>
                      <td>{ item.orderable.travel_package.type || '-' }</td>
                      <td>{ item.orderable.travel_package.destination_type || '-' }</td>
                      <td>{ item.orderable.inseption_date || '-' }</td>
                      <td>{ item.orderable.finish_date || '-' }</td>
                      <td>{ item.orderable.price_travel.currency_code || '-' } { item.orderable.price_travel.price || '-' }</td>
                    </tr>
                  )
                } else return null
              })
            }
          </tbody>
        </table>
      </section>
    )
  }

  _renderEcommerce = (data) => {
    return (
      <section className='section table-responsive'>
        <h5>E-Commerce</h5>
        <table className='table table-striped'>
          <thead>
            <tr>
              <th className='text-center'>Booking Number</th>
              <th className='text-center'>Qty</th>
              <th className='text-center'>Product Name</th>
              <th className='text-center'>Type</th>
              <th className='text-center'>Subtype</th>
            </tr>
          </thead>
          <tbody>
            {
              data.order_details && data.order_details.map((item, i) => {
                if (item.type === 'inventory') {
                  return (
                    <tr key={i}>
                      <td className='text-center'>{ item.booking_number || '' }</td>
                      <td className='text-center'>{ item.orderable.qty || '' }</td>
                      <td className='text-center'>{ item.orderable.inventory_item.inventory.name || '' }</td>
                      <td className='text-center'>{ item.orderable.inventory_item.varian_size.name || '' }</td>
                      <td className='text-center'>{ item.orderable.inventory_item.varian_colour.name || '' }</td>
                    </tr>
                  )
                } else return null
              })
            }
          </tbody>
        </table>
      </section>
    )
  }

  _renderEsim = (data) => {
    return (
      <section className='section table-responsive'>
        <h5>eSIM</h5>
        <table className='table table-striped'>
          <thead>
            <tr>
              <th className='text-center'>Booking Number</th>
              <th className='text-center'>Qty</th>
              <th className='text-center'>eSIM Name</th>
              <th className='text-center'>Data Size</th>
              <th className='text-center'>Day(s)</th>
            </tr>
          </thead>
          <tbody>
            {
              data.order_details && data.order_details.map((item, i) => {
                if (item.type === 'esim') {
                  return (
                    <tr key={i}>
                      <td className='text-center'>{ item.booking_number || '' }</td>
                      <td className='text-center'>{ item.orderable.qty || '' }</td>
                      <td className='text-center'>{ item.orderable.variant.esim.name || '' }</td>
                      <td className='text-center'>{ item.orderable.variant.data_size || '' }</td>
                      <td className='text-center'>{ item.orderable.variant.day || '' }</td>
                    </tr>
                  )
                } else return null
              })
            }
          </tbody>
        </table>
      </section>
    )
  }

  render () {
    const { order } = this.props
    const data = order.data_single
    return (
      <div className='section' style={{ width: '80vw' }}>
        <header className='title-block'>
          <h4 className='title mr-auto'>
            Order Detail
            {
              (order.fetching || order.processing) &&
              <div className='badge badge-info ml-2'>{order.fetching ? 'Loading' : 'Processing'} ...</div>
            }
          </h4>
        </header>
        {
          !(order.fetching || order.processing) && order.err &&
          <div className='alert alert-danger'>{order.err}</div>
        }
        <div className='title-block'>
          <div className='form-inline d-flex justify-content-between'>
            <div className='form-group'>
              <label className='control-label mr-2'>Unique Number</label>
              <label className={`badge badge-secondary`} style={{ fontSize: '100%' }}>
                { data.unique_number }
              </label>
            </div>
            <div className='form-group'>
              <label className='control-label mr-2'>Status</label>
              <label className={`badge badge-secondary`} style={{ fontSize: '100%' }}>
                { data.status }
              </label>
            </div>
          </div>
        </div>

        <div className='row'>
          <div className='col-6'>
            <div className='section'>
              <div className='form-group row'>
                <div className='col-4'>
                  <label className='control-label'>Name</label>
                </div>
                <div className='col-8'>
                  { `${data.salutation || '-'} ${data.first_name || '-'} ${data.last_name || '-'}` }
                </div>
              </div>
              <div className='form-group row'>
                <div className='col-4'>
                  <label className='control-label'>Email</label>
                </div>
                <div className='col-8'>
                  { data.email || '-' }
                </div>
              </div>
              <div className='form-group row'>
                <div className='col-4'>
                  <label className='control-label'>Phone Number</label>
                </div>
                <div className='col-8'>
                  { data.phone_number || '-' }
                </div>
              </div>
              <div className='form-group row'>
                <div className='col-4'>
                  <label className='control-label'>Create Date</label>
                </div>
                <div className='col-8'>
                  { moment.unix(data.created_at).format(this.dateFormat) || '-' }
                </div>
              </div>
              <div className='form-group row'>
                <div className='col-4'>
                  <label className='control-label'>Currency Code</label>
                </div>
                <div className='col-8'>
                  { data.currency_code || '-' }
                </div>
              </div>
            </div>
          </div>
          <div className='col-6'>
            <div className='section'>
              <div className='form-group row'>
                <div className='col-4'>
                  <label className='control-label'>Total Admin Fee</label>
                </div>
                <div className='col-8 text-right'>
                  { accounting.formatMoney(data.total_admin_fee, { format: '%v', thousand: ',', decimal: '.', precision: 2 }) }
                </div>
              </div>
              <div className='form-group row'>
                <div className='col-4'>
                  <label className='control-label'>Total Deposit</label>
                </div>
                <div className='col-8 text-right'>
                  { accounting.formatMoney(data.total_deposit_amount, { format: '%v', thousand: ',', decimal: '.', precision: 2 }) }
                </div>
              </div>
              <div className='form-group row'>
                <div className='col-4'>
                  <label className='control-label'>Total Amount</label>
                </div>
                <div className='col-8 text-right'>
                  { accounting.formatMoney(data.total_amount, { format: '%v', thousand: ',', decimal: '.', precision: 2 }) }
                </div>
              </div>
              <div className='form-group row'>
                <div className='col-4'>
                  <label className='control-label'>Discount Amount</label>
                </div>
                <div className='col-8 text-right'>
                  { accounting.formatMoney(data.discount_amount, { format: '%v', thousand: ',', decimal: '.', precision: 2 }) }
                </div>
              </div>
              <div className='form-group row'>
                <div className='col-4'>
                  <label className='control-label'>Insurance Amount</label>
                </div>
                <div className='col-8 text-right'>
                  { accounting.formatMoney(data.total_insurance, { format: '%v', thousand: ',', decimal: '.', precision: 2 }) }
                </div>
              </div>
              <div className='form-group row'>
                <div className='col-4'>
                  <label className='control-label'>Final Amount</label>
                </div>
                <div className='col-8 text-right'>
                  { accounting.formatMoney(data.final_amount, { format: '%v', thousand: ',', decimal: '.', precision: 2 }) }
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='title-block'>
          <h4 className='title mr-auto'>Order Items</h4>
        </div>

        {/* ATTRACTIONS */}
        { this._renderAttraction(data) }

        {/* MODEM */}
        { this._renderModem(data) }

        {/* EVENTS ORDER DETAIL */}
        { this.currentBranch !== 'PH' && this._renderEvents(data) }

        {/* INSURANCE PRODUCT ORDER DETAIL */}
        { this.currentBranch !== 'PH' && this._renderInsurance(data) }

        {/* ECOMMERCE PRODUCT ORDER DETAIL */}
        { this._renderEcommerce(data) }

        {/* eSIM Product Detail */}
        { this._renderEsim(data) }

        <div className='text-right'>
          <button type='button' className='btn btn-lg btn-secondary mr-2' onClick={() => this.props.closeModal()}>Close</button>
        </div>
      </div>
    )
  }
}

const stateToProps = (state) => ({
  order: state.order
})

const dispatchToProps = (dispatch) => ({
  getData: (id) => dispatch(OrderActions.orderSingleRequest(id))
})

export default connect(stateToProps, dispatchToProps)(ViewDetail)



// WEBPACK FOOTER //
// ./src/Containers/Order/ViewDetail.js